import { useState } from 'react';
import { Crown } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { Alert } from '@/components/ui/Alert';

const SWATCHES = ['#E5484D', '#F97316', '#EAB308', '#22C55E', '#06B6D4', '#3B82F6', '#8B5CF6'];

export function BoosterPage() {
  const [name, setName] = useState('Booster');
  const [color, setColor] = useState(SWATCHES[4]);

  return (
    <div className="space-y-6">
      <Alert
        tone="info"
        title="Your own role only"
        description="Boosters can only ever edit their own custom role — this page never lets you edit anyone else's."
      />

      <Card>
        <CardHeader title="Your booster role" description="Available to current server boosters." />

        <label className="text-small text-text-secondary block mb-1">Role name</label>
        <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={32} className="mb-4" />

        <label className="text-small text-text-secondary block mb-2">Color</label>
        <div className="flex gap-2 mb-4">
          {SWATCHES.map((swatch) => (
            <button
              key={swatch}
              type="button"
              onClick={() => setColor(swatch)}
              aria-label={`Choose color ${swatch}`}
              className={[
                'h-11 w-11 rounded-full border-2 transition-transform',
                color === swatch ? 'border-text-primary scale-110' : 'border-transparent',
              ].join(' ')}
              style={{ backgroundColor: swatch }}
            />
          ))}
        </div>

        <div className="flex items-center gap-2 bg-bg-base border border-border-subtle rounded-sm p-3 mb-4">
          <Crown size={16} style={{ color }} aria-hidden="true" />
          <span className="text-body-medium" style={{ color }}>
            {name || 'Booster'}
          </span>
        </div>

        <Button variant="primary" disabled>
          Save role
        </Button>
      </Card>
    </div>
  );
}
